import { useCheckoutState } from '../../utils/checkoutState';
import useAdyen, { AdyenConfig, AdyenParams } from '../../utils/useAdyen';

// https://docs.adyen.com/payment-methods/ideal/web-component/
const SpayAdyenIdealPayment = () => {
  const { adyenSpecificationPayloadRef } = useCheckoutState();

  const adyenConfig: AdyenConfig = {
    withPspSession: true,
    payButton: 'base',
    onChange: ({ data }: AdyenParams) => {
      const { paymentMethod, origin, browserInfo } = data;
      adyenSpecificationPayloadRef.current = { paymentMethod, origin, browserInfo };
    }
  };

  return useAdyen({ name: 'ideal', adyenConfig, withActions: true });
};

export default SpayAdyenIdealPayment;
